import { useState, useEffect } from 'react'

/**
 * Custom hook to detect screen size and determine if it's mobile
 * @param {number} breakpoint - The breakpoint for mobile detection (default: 575px)
 * @returns {boolean} isMobile - Whether the screen is mobile size
 */
const useScreenSize = (breakpoint = 575) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= breakpoint)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [breakpoint])

  return isMobile
}

export default useScreenSize
